import { EventCategory } from '@fluidx/office-fluid-types';
import { BaseOtelLogProcessor } from '../BaseOtelLogProcessor';
export class FluidLogProcessor extends BaseOtelLogProcessor {
    constructor(context, initialPersistentProps) {
        super(context.audience, initialPersistentProps);
        this.context = context;
        this.loadFullCalled = false;
    }
    /**
     * Method that logs the telemetry event based on the event category
     * @param event Telemetry event with namespace, category and a property bag of other fields
     */
    async logEvent(event) {
        // If the logger hasn't been fully loaded but an error occurs, load OneDs Sink.
        // This starts flushing the events and ensures telemetry for any crashes gets sent to the pipeline.
        if (event.category === EventCategory.Error) {
            if (!this.loadFullCalled) {
                this.loadFull().catch(() => {
                    // We do not need to explicitly handle the catch here as loadFull handles it internally
                });
            }
        }
        // Calling BaseOtelLogProcessor LogEvent
        return super.logEvent(event);
    }
    setUserContext(userContext) {
        // We update the OtelLogProcessor's context, to ensure full context is replayed if this method is called before loadFull was called
        // loadFull creates the telemetry sink and provides the context to it, so those fields can be added as Part A fields when the sink is created
        this.context = { ...this.context, ...userContext };
        this.telemetrySink?.setPartADataFields(this.context);
    }
    shutdown() {
        super.shutdown();
        // If OneDsSink has not been fully loaded, call loadFull on it first then call shutdown
        this.loadFull()
            .then(() => this.telemetrySink?.shutdown())
            .catch(() => {
            // We do not need to explicitly handle the catch here as loadFull handles it internally
        });
    }
    /**
     * Loads the OneDS Sink, replays events in the queue on the sink so the events are sent for logging.
     * Invoking this for a second or higher time will be a no-op.
     */
    async loadFull() {
        if (this.loadFullCalled) {
            return;
        }
        this.loadFullCalled = true;
        import(/* webpackChunkName: "officeFluidOneDsSink" */ './OfficeFluidOneDsSink')
            .then((m) => {
            this.telemetrySink = new m.OfficeFluidOneDsSink(this.context);
            this.telemetryLogger.addSink(this.telemetrySink.createOneDsSink());
            this.telemetryLogger.flushQueue();
        })
            .catch((error) => {
            this.logDefaultEventToOtel({
                category: EventCategory.Error,
                props: { eventName: 'LoggerLoadFailure', message: error.message, stack: error.stack }
            });
        });
    }
}
// cspell:ignore otel, oteljs
//# sourceMappingURL=FluidLogProcessor.js.map